<div class="container py-5">
  <div class="row align-items-center">
    <!-- Columna Izquierda: Título y Descripción -->
    <div class="col-12 col-lg-4 mb-5 mb-lg-0">
      <h2 class="title-faq-main fw-bold">
        <span class="d-none d-lg-block pt-5">Preguntas<br>Frecuentes</span>
        <span class="d-block d-lg-none">Preguntas Frecuentes</span></h2>
      <p class="subtitle-faq mt-4">
        Todo lo que debes saber para aprovechar al máximo tu asistencia de viaje.
      </p>
      <a routerLink="/preguntas-frecuentes" class="text-decoration-none faq-help-link mt-4 d-inline-block">
        ¿No encuentras tu pregunta? <i class="fa fa-arrow-right ms-2"></i>
      </a>
    </div>

    <!-- Columna Derecha: Acordeón -->
    <div class="col-12 col-lg-8 faq-cont">
      <ngb-accordion [closeOthers]="true" [animation]="'slide'" class="text-black grid-card-new" id="faqAccordion">
        <ngb-panel id="panelOne" cardClass="panel-faq-new">
          <ng-template ngbPanelTitle>
            <h3 class="fw-medium lh-1 mb-0 font-size-17">¿Qué hacer si necesitas asistencia durante tu viaje?</h3>
          </ng-template>
          <ng-template ngbPanelContent>
            <p class="font-size-15 mb-0 ">
              Si necesitas asistencia médica o por cualquier imprevisto con tu viaje (equipaje, vuelo u otros servicios), comunícate de inmediato con nuestra central de asistencia disponible 24/7 por llamada, chat o WhatsApp. Es importante que reportes el evento dentro de las primeras 24 horas para recibir orientación y seguimiento oportuno. En caso de una emergencia vital, acude al centro médico más cercano y contáctanos lo antes posible.
            </p>
          </ng-template>
        </ngb-panel>
        <ngb-panel id="panelTwo" cardClass="panel-faq-new">
          <ng-template ngbPanelTitle>
            <h3 class="fw-medium lh-1 mb-0 font-size-17">
              ¿Cuándo es recomendable comprar mi asistencia de viaje?
            </h3>
          </ng-template>
          <ng-template ngbPanelContent>
            <p class="font-size-15 mb-0 ">
              Puedes comprar tu asistencia en cualquier momento. Sin embargo, te recomendamos hacerlo al menos 48 horas antes del inicio de tu viaje para evitar imprevistos y contar con el tiempo necesario para realizar cambios o modificaciones si lo requieres.
            </p>
          </ng-template>
        </ngb-panel>
        <ngb-panel id="panelThree" cardClass="panel-faq-new">
          <ng-template ngbPanelTitle>
            <h3 class="fw-medium lh-1 mb-0 font-size-17">
              ¿La asistencia tiene copago o pagos adicionales?
            </h3>
          </ng-template>
          <ng-template ngbPanelContent>
            <p class="font-size-15 mb-0 ">
              El copago depende del plan que hayas adquirido. Te recomendamos revisar tu certificado de asistencia; si el ítem “copago” aparece en cero, no deberás asumir pagos adicionales por ese servicio.
            </p>
          </ng-template>
        </ngb-panel>
        <ngb-panel id="panelFour" cardClass="panel-faq-new">
          <ng-template ngbPanelTitle>
            <h3 class="fw-medium lh-1 mb-0 font-size-17">
              ¿Qué asistencias no médicas están cubiertas y cómo solicitarlas?
            </h3>
          </ng-template>
          <ng-template ngbPanelContent>
            <p class="font-size-15 mb-0 ">
              La asistencia de viaje cubre situaciones no médicas como pérdida de equipaje o elementos electrónicos, retraso de vuelo, cancelación de viaje, entre otros beneficios, según el plan adquirido.<br>
              Es importante que revises tu certificado para confirmar la cobertura y reportes el evento de inmediato a nuestra central de asistencia, preferiblemente antes de salir del aeropuerto, ya que algunos servicios requieren notificación inmediata para su gestión.
            </p>
          </ng-template>
        </ngb-panel>
      </ngb-accordion>
    </div>
  </div>
</div>
<!--<div class="container-fluid bg-quote-faq">
  <button type="button" (click)="openDialog()" class="btn btn-danger texte-center btn-quote-faq">COTIZAR GRATIS</button>
</div>-->
<!--<div class="container mt-5">
  <h2 class="title-blue text-center font-size-32">Juntos Somos Más</h2>
  <p class="text-lg-center text-justify mt-4">
    <span class="text-blue-tas fw-bolder">¡Lo que es importante para ti, es importante para nosotros!</span>
    <br class="d-none d-lg-block" />
    Seguimos trabajando activamente en conjunto con nuestros aliados para brindarte las mejores soluciones médicas y
    legales cuando viajas.
  </p>
  <div class="row d-none d-md-flex mb-5 mt-5">
    <div class="col-4 center-img mb-4">
      <img
        ngSrc="https://res.cloudinary.com/pervolare-org/image/upload/v1698815081/TAS/home/Logo_VTC_o99hqh.png"
        alt="logo vtc"
        width="199.96px"
        height="43.82px"
      />
    </div>
    <div class="col-4 center-img mb-4">
      <img
        ngSrc="https://res.cloudinary.com/pervolare-org/image/upload/v1698815080/TAS/home/logo-DKV-tas_uvp0a7.png"
        alt="logo dkv"
        width="121.14px"
        height="46.098px"
      />
    </div>
    <div class="col-4 center-img mb-4">
      <img
        ngSrc="https://res.cloudinary.com/pervolare-org/image/upload/v1698815070/TAS/home/Logo-SPV_egnbgt.png"
        alt="logo spv"
        width="212.13px"
        height="42.468px"
      />
    </div>
  </div>
  <div class="row mt-5 d-md-none" id="faqCarousel">
    <div class="col-12">
      <ngb-carousel class="h-carousel">
        <ng-template ngbSlide>
          <div class="center-img">
            <img
              ngSrc="https://res.cloudinary.com/pervolare-org/image/upload/v1698815081/TAS/home/Logo_VTC_o99hqh.png"
              alt="logo vtc"
              width="199.96px"
              height="43.82px"
            />
          </div>
        </ng-template>
        <ng-template ngbSlide>
          <div class="center-img">
            <img
              ngSrc="https://res.cloudinary.com/pervolare-org/image/upload/v1698815080/TAS/home/logo-DKV-tas_uvp0a7.png"
              alt="logo dkv"
              width="121.14px"
              height="46.098px"
            />
          </div>
        </ng-template>
        <ng-template ngbSlide>
          <div class="center-img">
            <img
              ngSrc="https://res.cloudinary.com/pervolare-org/image/upload/v1698815070/TAS/home/Logo-SPV_egnbgt.png"
              alt="logo spv"
              width="212.13px"
              height="42.468px"
            />
          </div>
        </ng-template>
      </ngb-carousel>
    </div>
  </div>
</div>-->
